/* Shared constants + static data for HomePage sections */
import { Users, BarChart3, MapPin, Network, PenLine, Package } from 'lucide-react';

export const WAVE_WINS = [
  { creator: '@sleepcoach_mia',        event: 'hit 3.2M impressions in 47 minutes',    metric: '+214% velocity' },
  { creator: '#GlowChallenge',         event: 'trending in 14 states',                  metric: '89 creators joined' },
  { creator: '@lunasips',              event: 'smoothie reel went mega-viral',          metric: '312K shares in 2hrs' },
  { creator: '@hydratewithjax',        event: 'hit Explore page on Instagram',          metric: '+4.8x velocity spike' },
];

// The six 1st Party Data Room data types — same identifiers and copy
// the backend serves at /api/brand/data-room/status. Kept in sync with
// `CARD_META` in routes/first_party_data.py.
export const UPLOAD_CARDS = [
  { id: 'customer_segments',      title: 'Customer Segments',
    format: 'CSV (segment, customer_id, ltv, state)',
    benefit: 'Helps us match creators whose audiences actually reach your real buyers.',
    icon: Users },
  { id: 'performance_history',    title: 'Performance History',
    format: 'CSV (campaign_name, impressions, conversions, revenue)',
    benefit: 'Teaches the system what worked best for you so future waves perform better.',
    icon: BarChart3 },
  { id: 'geographic_performance', title: 'Geographic Performance',
    format: 'CSV (state, stores, customers, revenue, roas)',
    benefit: 'Lets us prioritise creators in the locations that matter most to you.',
    icon: MapPin },
  { id: 'audience_overlap',       title: 'Audience Overlap Data',
    format: 'CSV (creator_id, overlap_pct)',
    benefit: 'Improves diversity scoring so you reach new customers instead of the same ones.',
    icon: Network },
  { id: 'creative_insights',      title: 'Creative Insights',
    format: 'CSV (angle, performance_score, sample_copy)',
    benefit: 'Gives smarter angle and caption recommendations in the SKU modal.',
    icon: PenLine },
  { id: 'sku_performance',        title: 'SKU Performance Data',
    format: 'CSV (sku_id, impressions, conversions, revenue)',
    benefit: 'Connects product-level results to creator selection so your best-performing products guide future waves.',
    icon: Package },
];

export const ANNOUNCEMENT = {
  id: 'data-room-launch-2026-05',
  text: 'New: 1st Party Data Room — smarter matching, better waves.',
  cta: 'Explore',
  to: '/data-room',
};
